import { faMessageLines } from "@fortawesome/pro-solid-svg-icons";

import { Icon } from "src/design-system/Icon";
import { MAX_DISPLAY_COUNT } from "src/utils/constants";
import { getMaximumDisplayedCount } from "src/utils/stringUtils";

type Props = {
  count: number;
};

export const CommentCount: React.FC<Props> = ({ count }) => {
  const displayCount = getMaximumDisplayedCount(count, MAX_DISPLAY_COUNT);
  return (
    <div className="flex h-4 flex-row items-center rounded bg-yellow-100 px-1">
      <Icon icon={faMessageLines} size="3xs" variant="warning" />
      <p className="font-inter-normal-12px text-yellow-700">{displayCount}</p>
    </div>
  );
};
